import updateLoanSectionData from "components/Loans/LoanStepper/components/lib/updateLoanSectionData";

async function updateLoanSectionController(
  user,
  loanSectionController,
  currentLoan,
  setCurrentLoan = false
) {
  // for security reasons to compare those value on backend

  // all the query params need to be provided
  const targetUrl = `${process.env.CMS_URL}/loans/${currentLoan.id}`;
  const token = await user.getIdToken();
  // dataTranslation
  const res = await fetch(targetUrl, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      LoanSectionController: loanSectionController,
    }),
  });

  const respJSON = await res.json();

  if (setCurrentLoan) {
    setCurrentLoan(respJSON);
  }

  return respJSON;
}

export default updateLoanSectionController;
